import React from 'react';
//components
import CitySearch from '@/components/CitySearch';
//stores
import useConfigStore from '@/stores/Configs';
import useSearchCampaignStore from '@/stores/SearchCampaign';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
//constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
//styles
import styles from './Filters.module.scss';
const Cities = () => {
    const cityOptions = useConfigStore((state) => state.cities);
    const { cityIds, setCityIds } = useSearchCampaignStore((state) => ({
        cityIds: state.cityFilter.cityIds,
        setCityIds: state.cityFilter.setCityIds,
    }));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(Text, { className: styles.filterLabel, variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Highest_Emphasis }, "City"),
            React.createElement(CitySearch, { cityOptions: cityOptions, selectedOptions: cityIds.map((i) => i.toString()), setSelectedOptions: setCityIds })),
        !!cityIds.length && (React.createElement("div", { className: styles.selectedCount },
            React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Low_Emphasis },
                cityIds.length,
                " cities selected")))));
};
export default Cities;
